<template>
<div>
  <MatchPage :key="id" v-on:childToParent="onChildClick"/>
  </div>
</template>

<script>
import MatchPage from './MatchPage'
import { mapGetters } from 'vuex';

export default {
  name: 'MatchPagePar',
  data(){
      return{
          MatchStats: [],
          leagueTable: [],
          gamesTween: [],
          gameId: '',
          teamLogo: 'https://sportapi.zuniac.com/team/logo/',
          leagueId: '',
          team1name:'',
          team2name:'',
          teamID:'',
          id : '10420661',
          cookiesObject: '',
          max: 100,
          newArray1: [],
          newArray2: [],
          summedArray: [],
      }
  },
  async mounted(){

  },

  components: {
      MatchPage,
  },   
  methods : {
     onChildClick (value) {
      this.id = value;
      this.$route.params.gameId = value;
    },
  },
  computed: {
      ...mapGetters(['token']),
  },
}

</script>

<style scoped>
.team2{
  text-align: right;
}
.blackBg{
    background: #e6e6e6;

}

.yellowBg{
  background: #d8c866;
}
 
.Loc{
    background-image: url("https://zunisport.com/style/path/img/soccer-cover.jpg");
    background-size:cover ;
    width: 100%;
    height: 300px;
    margin-top: -17px;
}
.circle {
    background: #333333;
    width: 40px;
    height: 40px;
    border-radius: 50%;
}

.leagueNam{
    text-align:center; 
    padding-top: 70px;
    font-size: 18px;
    color: white;
}


/* Navbar (info, H2H, etc.) */


.navDiv2{
    width: 100%;
    height: 60px;
    color: white;
    background-image: linear-gradient(#fefefe , #c3c3c3);  
}

#topheader2 .navbar-nav li > a {
	text-transform: capitalize;
    transition: background-color 0.2s, color 0.2s;
}

    #topheader2 .navbar-nav li > a:focus {
        background-image: linear-gradient(#39b44a , #39b54a);
        color: #fff !important;
	}

#topheader2 .navbar-nav li.active > a {
	background-color: #333;
	color: #fff;
}

#routerLink{
  padding-top: 10%;
    display: inline-block; 
    text-decoration: none;
    width: 111px !important;
    height: 60px !important;
    color: black !important;
    text-align: center !important;
    margin-top: -8px;
}
#routerLink .navbar-nav li > a {
	text-transform: capitalize;
	transition: background-color 0.2s, color 0.2s;
    
}

    #routerLink .navbar-nav li > a:focus {
        background-image: linear-gradient(#39b44a , #1b5f20);
		color: #fff !important;
	}

#routerLink .navbar-nav li.active > a {
	background-color: #333;
	color: #fff;
}

.Info{
    width: 100%;
}

.list-group-item{
    line-height: 15px;
}

.listHeader{
  background-color: #333333 !important;  
  color: white;
  text-align: center;
  font-weight: 400;
  font-size: 15px;
}

.infoItem{
background-color: #4d4d4d !important;
color: white;
border-color: #333333 !important;
border-width: 1px !important;
}

/* bottom of the page info css (referee, stadium) */

.referee{
background-color: #4d4d4d !important;
color: white;
border: none;
}

@media only screen and (max-width: 600px) {
  body{
    background: #212529;
  }
  .Loc{
    background-image: url("https://zunisport.com/style/path/img/soccer-cover.jpg");
    background-size: cover ;
    width: 90% !important;
    height: 300px;
    margin-top: -17px;
}
.blackBg{
  background: #e6e6e6;
}
  .navDiv2{
    width: 100%;
    height: 60px;
    color: white;
    background: #1b1d20;  
}
.leagueNam{
    text-align:center; 
    padding-top: 20px;
    font-size: 15px;;
    color: white;
  justify-content: center;
  }

  .MobileHide {
    display: none;
  }
}

@media only screen and (min-width: 600px) {
  .MobileShow {
    display: none;
  }

}
</style>
